import { t } from "@lingui/core/macro";
import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "@/utils/hooks/useMutationWithError";
import { getSquarePaymentErrorMessage } from "@whoosh/utilities/src/Square/squareErrorMessages";

import {
  CreateOrderPaymentInput,
  usePayOutstandingOrderMutation,
} from "./__generated__/usePayOutstandingOrderMutation.graphql";

export const usePayOutstandingOrder = () => {
  const [payOrder, isPaying] =
    useMutationWithError<usePayOutstandingOrderMutation>(
      usePayOutstandingOrderMutationString
    );

  const handlePayOrder = (
    input: CreateOrderPaymentInput,
    onSuccess?: () => void,
    onError?: (error: Error) => void
  ) => {
    payOrder({
      variables: { input },
      onCompleted: () => {
        onSuccess?.();
      },
      onCompletedErrorCustom: (errors) => {
        const errorMessages =
          errors
            .map((err) => getSquarePaymentErrorMessage(err.code))
            .find(Boolean) ||
          errors
            .map((err) => err.code)
            .filter(Boolean)
            .join(", ");
        onError?.(new Error(t`Payment failed: ${errorMessages}`));

        return [];
      },
      onPayloadError: (errors) => {
        const errorMessages = errors.map((err) => err.message).join(", ");
        onError?.(new Error(t`Payment failed: ${errorMessages}`));
      },
      onErrorCustom: (error) => {
        onError?.(error);
      },
    });
  };

  return [handlePayOrder, isPaying] as const;
};

const usePayOutstandingOrderMutationString = graphql`
  mutation usePayOutstandingOrderMutation($input: CreateOrderPaymentInput!) {
    responsePayload: createOrderPayment(input: $input) {
      success
      errors {
        code

        message
        field
      }
      order {
        id
        status
      }
    }
  }
`;
